import { render } from "./SystemStatus.vue?vue&type=template&id=20bada78"
import script from "./SystemStatus.vue?vue&type=script&lang=js"
export * from "./SystemStatus.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__